import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import useFavorites from '../hooks/useFavorites';

const FavoritesContext = createContext(null);

/**
 * Provider component for favorites state management
 * Wraps the useFavorites hook in a context for global access
 */
export const FavoritesProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const favoritesState = useFavorites(isAuthenticated, location.pathname);

  return (
    <FavoritesContext.Provider value={favoritesState}>
      {children}
    </FavoritesContext.Provider>
  );
};

/**
 * Hook to access favorites context
 * @returns {Object} Favorites state and methods
 */
export const useFavoritesContext = () => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error('useFavoritesContext must be used within a FavoritesProvider');
  }
  return context;
};

export default FavoritesContext;
